export default "__VITE_ASSET__iGOmSt_o__"